export default "__VITE_ASSET__8lnnI9gX__"